<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col>
        <setup-skills-categories-dialog-create @created="created" />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(category, i) in categories"
        :key="category.id"
        cols="12"
        md="4"
        xl="3"
      >
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="[`elevation-${hover ? 12 : 2}`, 'pa-2']" 
          >
            <v-card-actions>
              <span class="font-weight-medium text-capitalize text-truncate">{{ category.name }}</span>
              <v-spacer />
            
              <setup-skills-categories-dialog-edit 
                :skill-category="category"
                :index="i"
                @updated="updated(...arguments)"
              />    
              <setup-skills-categories-dialog-delete 
                :skill-category="category"
                :index="i"
                @deleted="deleted"
              />
            </v-card-actions>       
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row
      v-show="!categories && loading === false"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <div class="headline">
          <span class="blue-grey--text">No Data Available</span>
        </div>
      </v-col>   
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupSkillsCategoriesDialogCreate: () => import('@/components/setup/skills/categories/DialogCreate'),
      SetupSkillsCategoriesDialogEdit: () => import('@/components/setup/skills/categories/DialogEdit'),
      SetupSkillsCategoriesDialogDelete: () => import('@/components/setup/skills/categories/DialogDelete'),
    },
    metaInfo () {
      return {
        title: 'Setup - Skill Categories',
      }
    },
    data: () => ({
      categories: null,
      loading: true,
    }),
    created () {
      this.$api.skillCategories().list()
        .then(response => {
          this.categories = response.data
          this.loading = false
        })    
    },
    methods: {
      created (category) {
        this.categories.unshift(category)
      },
      updated (category, index) {
        this.$set(this.categories, index, category)
      },
      deleted (index) {
        this.categories.splice(index, 1)
      },
    },
  }
</script>
